import { render, staticRenderFns } from "./deduct.vue?vue&type=template&id=61e58883&scoped=true&"
import script from "./deduct.vue?vue&type=script&lang=js&"
export * from "./deduct.vue?vue&type=script&lang=js&"
import style0 from "./deduct.vue?vue&type=style&index=0&id=61e58883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e58883",
  null
  
)

export default component.exports